var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_40460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93529 3.98138C5.27798 3.98138 3.92971 5.32992 3.92971 6.98723C3.92971 8.64454 5.27798 9.99307 6.93529 9.99307C8.59233 9.99307 9.94087 8.6448 9.94087 6.98723C9.94087 5.32966 8.59233 3.98138 6.93529 3.98138Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93529 3.09783C6.61137 3.09783 6.34884 2.8353 6.34884 2.51165V1.57339C6.34884 1.24947 6.61137 0.986938 6.93529 0.986938C7.2592 0.986938 7.52174 1.24947 7.52174 1.57339V2.51165C7.52174 2.8353 7.25894 3.09783 6.93529 3.09783Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93529 10.8758C6.61137 10.8758 6.34884 11.1383 6.34884 11.4622V12.4002C6.34884 12.7244 6.61137 12.987 6.93529 12.987C7.2592 12.987 7.52174 12.7244 7.52174 12.4002V11.4622C7.52174 11.1383 7.25894 10.8758 6.93529 10.8758Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68498 4.23699C9.45619 4.00793 9.45619 3.63672 9.68498 3.40767L10.3485 2.74416C10.5773 2.51537 10.9488 2.51537 11.1778 2.74416C11.4069 2.97321 11.4069 3.34469 11.1778 3.57348L10.5143 4.23699C10.2855 4.46604 9.9143 4.46604 9.68498 4.23699Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18533 9.73717C3.95628 9.50786 3.58506 9.50786 3.35601 9.73717L2.6925 10.4004C2.46372 10.6292 2.46345 11.0009 2.6925 11.2297C2.92155 11.4585 3.29303 11.4585 3.52182 11.2297L4.18533 10.566C4.41438 10.3372 4.41438 9.96569 4.18533 9.73717Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8241 6.98696C10.8241 6.66305 11.0867 6.40051 11.4106 6.40051H12.3488C12.6728 6.40051 12.9353 6.66305 12.9353 6.98696C12.9353 7.31088 12.6728 7.57314 12.3488 7.57314H11.4106C11.0867 7.57314 10.8241 7.31088 10.8241 6.98696Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04618 6.98696C3.04618 6.66305 2.78365 6.40051 2.45973 6.40051H1.52174C1.19782 6.40051 0.935287 6.66305 0.935287 6.98696C0.935287 7.31088 1.19782 7.57314 1.52174 7.57314H2.46C2.78365 7.57314 3.04618 7.31088 3.04618 6.98696Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68498 9.73714C9.91403 9.50836 10.2855 9.50836 10.5143 9.73714L11.1778 10.4006C11.4069 10.6292 11.4069 11.0009 11.1778 11.2297C10.9488 11.4585 10.5775 11.4585 10.3485 11.2297L9.68498 10.5662C9.45593 10.3371 9.45593 9.96593 9.68498 9.73714Z",
    fill: "#D4D7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18533 4.23698C4.41438 4.00793 4.41438 3.63671 4.18533 3.40766L3.52182 2.74442C3.29277 2.51537 2.92156 2.51537 2.6925 2.74442C2.46345 2.97321 2.46345 3.34469 2.6925 3.57347L3.35601 4.23698C3.58506 4.4663 3.95628 4.4663 4.18533 4.23698Z",
    fill: "#D4D7DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_40460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.935287 0.986938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.f42183702835244bd1e9f28a23020192.svg";
export { ForwardRef as ReactComponent };